import React from "react";
import { ResponsiveImage } from "./responsive-image";
/**
 * This component can be used for adding image gallery on the story page.
 *
 * Example
 * ```javascript
 * import { ImageGalleryElement } from "@quintype/components";
 *
 * <ImageGalleryElement element={element} key={element.id} imageAspectRatio={[4,3]} />
 * ```
 * @category Story Page
 * @component
 */

export function ImageGalleryElement(_ref) {
  var className = _ref.className,
      imageAspectRatio = _ref.imageAspectRatio,
      defaultWidth = _ref.defaultWidth,
      element = _ref.element,
      widths = _ref.widths,
      story = _ref.story,
      onClickHandler = _ref.onClickHandler;
  element = element || {};
  var images = element['story-elements'].map(function (image, index) {
    return /*#__PURE__*/React.createElement("figure", {
      "data-test-id": "story-element-image-container",
      key: image.id,
      className: "story-element-image-gallery__image-container ".concat(onClickHandler ? 'custom-cursor' : ''),
      onClick: function onClick() {
        return onClickHandler && onClickHandler(index);
      }
    }, /*#__PURE__*/React.createElement(ResponsiveImage, {
      slug: image["image-s3-key"],
      metadata: image["metadata"],
      aspectRatio: imageAspectRatio ? imageAspectRatio : [1, 1],
      defaultWidth: defaultWidth ? defaultWidth : 480,
      widths: widths ? widths : [250, 480, 640],
      imgParams: {
        auto: ['format', 'compress']
      },
      className: className ? className : 'story-element-image-gallery__image',
      alt: image.title || story.headline
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "story-element-image-gallery",
    "data-test-id": "story-element-image-gallery"
  }, images);
}